import { EPricePeakType, EPriceTime, E_PRICE_PEAK_TYPE_MAP } from '../../api/electricityPrice';

export const getItemTime = (index: number) => zeroPad(Math.floor(index / 2), 2) + ':' + (index % 2 === 0 ? '00' : '30');

export const zeroPad = (num: number, places: number) => String(num).padStart(places, '0');

export const getItemTypes = (times: EPriceTime[]) =>
  times.reduce(
    (acc, cur) => {
      acc.splice(
        cur.intervalStart,
        cur.intervalEnd - cur.intervalStart + 1,
        ...new Array(cur.intervalEnd - cur.intervalStart + 1).fill(cur.type)
      );
      return acc;
    },
    [...new Array(48)]
  );

export const getPeriodTypes = (times: EPriceTime[]): EPriceTime[] =>
  getItemTypes(times).reduce((acc, cur, index) => {
    const last = acc[acc.length - 1];
    if (last && last.type === cur) {
      last.intervalEnd = index;
    } else {
      acc.push({
        type: cur,
        intervalStart: index,
        intervalEnd: index,
      });
    }
    return acc;
  }, [] as EPriceTime[]);

export const getPeriodTime = (time: EPriceTime) =>
  `${E_PRICE_PEAK_TYPE_MAP[time.type]}: ${getItemTime(time.intervalStart)}~${getItemTime(time.intervalEnd + 1)}`;

export const isFullDay = (times: EPriceTime[]) => !getItemTypes(times).some(t => t === undefined);

export const hasType = (times: EPriceTime[], type: EPricePeakType) => times && times.some(t => t.type === type);
